import Vue from 'vue';
import prompt from '@/components/Modal/ModalPrompt.vue';

const Prompt = Vue.extend(prompt);

const promptFun = function (options) {
  const Instance = new Prompt({
    data: {
      title: options?.title || 'title',
      placeholder: options?.placeholder || 'placeholder',
      inputType: options?.inputType || 'text',
      confirmText: options?.confirm || '確定',
      validation: options?.validation || (() => ({error: '', isPass: true})),
    },
  });
  if (options && options.slot) {
    Instance.$slots.main = options.slot;
  }
  const vm = Instance.$mount();
  document.body.appendChild(vm.$el);
  return vm.init();
};

export default promptFun;
